// extracted by mini-css-extract-plugin
module.exports = {"mobileAsset":"breakpoint-aware-asset_mobileAsset__r9_CW","desktopAsset":"breakpoint-aware-asset_desktopAsset__EwAg_"};